<template>
    <div class="full-container d-flex justify-content-center align-items-center">

        <div class="login-container p-5">
            <form v-on:submit.prevent="login" novalidate>
                <div class="form-group">
                    <label for="exampleInputEmail1">Email</label>
                    <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" v-model.trim="email">
                </div>
                <div class="form-group">
                    <label for="exampleInputPassword1">Passwort</label>
                    <input type="password" class="form-control" id="exampleInputPassword1" v-model.trim="password">
                </div>
                <div v-if="errorMessage" class="form-group login-error">
                    {{errorMessage}}
                </div>
                <button type="submit" class="btn btn-primary">Login</button>
            </form>
        </div>

    </div>
</template>

<script>

    import firebase from 'firebase/app';

    export default {
        name: "Login",

        data: () => {

            return {
                email: null,
                password: null,
                errorMessage: null
            }
        },
        methods: {
            login() {

                if (this.email && this.password) {
                    firebase.auth().signInWithEmailAndPassword(this.email, this.password)
                        .then(credentials => {
                            console.log(credentials);
                            this.errorMessage = null;
                            this.$router.replace({name: 'Dashboard'});
                        })
                        .catch(err => {
                            this.errorMessage = 'Deine Angaben sind leider falsch.'
                            console.log('FEHLER', err)
                        });
                } else {
                    this.errorMessage = 'Bitte um Eingabe';
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '~styles/container';
    @import '~styles/colors';

    .login-container {

        min-width: 400px;
        border-radius: 4px;
        border: 1px solid $border-color;
        -webkit-box-shadow: 0px 21px 55px -19px rgba(120,114,120,1);
        -moz-box-shadow: 0px 21px 55px -19px rgba(120,114,120,1);
        box-shadow: 0px 21px 55px -19px rgba(120,114,120,1);
        //background-color: $color-violet;
    }

    .login-error {
        color: red;
        font-size: 0.9rem;
        text-align: center;
    }
</style>